import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { HEADER_DATA_SOURCE } from '../../../externals';
import { useMutation } from '@apollo/client';
import { SET_ONBOARDING_MODAL_SEEN_TIME } from './onboardingOperations';
import { logGQLErrors } from '../../../shared/logGQLErrors';
export var useSetOnboardingModalSeenTime = function useSetOnboardingModalSeenTime() {
  var _useMutation = useMutation(SET_ONBOARDING_MODAL_SEEN_TIME, {
    context: _defineProperty({}, HEADER_DATA_SOURCE, true),
    onError: function onError(error) {
      return logGQLErrors('Header - Set onboarding modal seen time failed', error);
    }
  }),
      _useMutation2 = _slicedToArray(_useMutation, 1),
      setOnboardingModalSeenTime = _useMutation2[0];

  return function (lastSeenTime) {
    return setOnboardingModalSeenTime({
      variables: {
        lastSeenTime: lastSeenTime
      }
    });
  };
};